module.exports = __webpack_public_path__ + "static/media/0x_v3.735db5f3.svg";